import { networkActionsCreator } from '../../../../admincore'

const actions = {
  ...networkActionsCreator('importScheduledOrders'),
}

export default actions

export function load(params) {
  console.log('params', params)
  return {
    type: actions.LOAD,
    payload: {
      params,
    },
  }
}
